import React from 'react';

const Control = props => {
  return (
    <div className="controls">
      <button
        onClick={() => props.onZoom(true)}
        className="control"
        type="button"
      >
        <svg width="14" height="14" viewBox="0 0 14 14">
          <path d="M12 5h-3v-3c0-1.1-.9-2-2-2s-2 .9-2 2v3h-3c-1.1 0-2 .9-2 2s.9 2 2 2h3v3c0 1.1.9 2 2 2s2-.9 2-2v-3h3c1.1 0 2-.9 2-2s-.9-2-2-2z" />
        </svg>
      </button>
      <button
        onClick={() => props.onZoom(false)}
        className="control"
        type="button"
      >
        <svg width="14" height="14" viewBox="0 0 14 14">
          <path d="M12 5h-10c-1.1 0-2 .9-2 2s.9 2 2 2h10c1.1 0 2-.9 2-2s-.9-2-2-2z" />
        </svg>
      </button>
    </div>
  );
};

export default Control;
